import {
  DIM2CLASS
} from '../core/icon-class';

class FilterSearchController {
  constructor(
    $scope,
    CurrentFilterService,
    AggregateDataService,
    CurrentModelService,
    RouterService,
  ) {
    this.$scope = $scope;
    this.currentFilter = CurrentFilterService;
    this.filterBar = CurrentFilterService.filterBar;
    this.DIM2CLASS = DIM2CLASS;
    this.AggregateDataService = AggregateDataService;
    this.CurrentModelService = CurrentModelService;
    this.router = RouterService;
    this.value = '';
    this.previousValue = this.value;
    // this.title = gettext('Поиск - Ключевые слова');
    // this.titleCatalog = gettext('Поиск - Имя фильтра');
  }

  get panel() {
    return this.currentFilter.panel;
  }

  set panel(panel) {
    this.currentFilter.panel = panel;
  }

  get filter() {
    return this.currentFilter.filter;
  }

  set filter(filter) {
    this.currentFilter.filter = filter;
  }

  searchKeyup(event) {
    if (event.keyCode !== 13) {
      return;
    }

    return this.search();
  }

  searchClean() {
    this.value = '';
    this.search();
  }

  // searchFilters() {
  //   if (this.value === this.previousValue) return;
  //   this.previousValue = this.value;
  //   if (this.value) {
  //     this.currentFilter.FiltersService.searchFilters(f =>
  //       f.name.toLowerCase().indexOf(this.value.toLowerCase()) !== -1
  //     );
  //   } else this.currentFilter.FiltersService.searchFilters();
  //
  // }

  search() {
    // if (this.panel === 'catalog') return this.searchFilters();
    if (this.router.isFilterEditModal) {
      this.$scope.runClick({
        keyWord: this.value
      });
      // this.$scope.runClick(this.value);
    } else {
      const keywords = this.value;
      if (!keywords.trim()) {
        return;
      }
      const re = (keywords.match(/["'](.*)["']/));
      if (re) {
        this.router.addKeyword(re[1]);
      } else {
        keywords.split(' ').forEach((keyword) => {
          this.router.addKeyword(keyword);
        });
      }
    }
    this.value = '';
  }

}

export function FilterSearchComponent() {
  return {
    restrict: 'E',
    template: require('./filter-search.component.html'),
    // scope: true,
    scope: {
      runClick: '&'
    },
    controller: FilterSearchController,
    controllerAs: '$ctrl',
  };
}



// WEBPACK FOOTER //
// ./src/filter/filter-search.component.js